import * as React from "react";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import StatCard from "./StatCard";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogContent,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  dashboardApi,
  billUpdate,
  billFreightList,
} from "../../Services/Services";
import PrintIcon from "@mui/icons-material/Print";
import { Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
export default function MainGrid() {
  const [bill, setBill] = useState([]);
  const [totalFreight, setTotalFreight] = useState(0);
  const [totalBill, setTotalBill] = useState(0);
  const [todayFreight, setTodayFreight] = useState(0);
  const [todayBill, setTodayBill] = useState(0);
  const [monthlyFreight, setMonthlyFreight] = useState(0);
  const [monthlyBill, setMonthlyBill] = useState(0);
  const [billPendingFreight, setBillPendingFreight] = useState(0);
  const [billPendingBill, setBillPendingBill] = useState(0);

  const [editableRow, setEditableRow] = useState(null);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    const dashboardData = async () => {
      const data = await dashboardApi();
      if (data) {
        setBill(data.billing_data);
        setTotalFreight(data.total_freight);
        setTotalBill(data.total_billing);
        setTodayFreight(data.today_freight);
        setTodayBill(data.today_billing);
        setMonthlyFreight(data.current_month_freight);
        setMonthlyBill(data.current_month_billing);
        setBillPendingFreight(data.freight_pending_for_billing);
        setBillPendingBill(data.billing_pending_for_payment);
      }
    };
    dashboardData();
  }, []);

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    if (format === "dd-mm-yyyy") return `${day}-${month}-${year}`;
    else if (format === "yyyy-mm-dd") return `${year}-${month}-${day}`;
    else throw new Error("Unsupported format.");
  }

  const data = [
    {
      title: "Total Freights",
      value: totalFreight,
      interval: "Present",
      trend: "up",
    },
    {
      title: "Today Freights",
      value: todayFreight,
      interval: "Today Freights List",
      trend: "down",
    },
    {
      title: "Monthly Freights",
      value: monthlyFreight,
      interval: "Last 30 days",
      trend: "neutral",
    },
    {
      title: "Bill Pending Freights",
      value: billPendingFreight,
      interval: "Last 30 days",
      trend: "up",
    },
    {
      title: "Total Bills",
      value: totalBill,
      interval: "Total Party Bills",
      trend: "down",
    },
    {
      title: "Today Bills",
      value: todayBill,
      interval: "Today Created Bills",
      trend: "up",
    },
    {
      title: "Monthly Bills",
      value: monthlyBill,
      interval: "Last 30 days",
      trend: "up",
    },
    {
      title: "Payment Pending Bills",
      value: billPendingBill,
      interval: "Party Payment Pending Bills",
      trend: "down",
    },
  ];

  const getInitials = (str) =>
    str
      .split(" ")
      .filter((word) => word)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [rawBillData, setRawBillData] = useState([]);
  const handleEditClick = async (bill_id) => {
    const data = await billFreightList(bill_id);
    if (data) {
      setRawBillData(data.freights || []);
      setOpenEditModal(true);
    }
  };
  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard {...card} />
          </Grid>
        ))}
      </Grid>

      <Card variant="outlined" sx={{ width: "100%" }}>
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
          Bill List
        </Typography>

        <TableContainer sx={{ overflowX: "auto", mt: 2, maxWidth: "100%" }}>
          <Table
            size="small"
            sx={{
              tableLayout: "auto",
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "normal",
                padding: "0px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead
              sx={{
                "& th": {
                  fontWeight: "bold",
                  color: (theme) =>
                    theme.palette.mode === "dark" ? "#2196f3" : "#333",
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                },
              }}
            >
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell sx={{ maxWidth: "110px" }}>Party Name</TableCell>
                <TableCell>Bill ID</TableCell>
                <TableCell>Bill Date</TableCell>
                <TableCell>No. of Days</TableCell>
                <TableCell>Total Amt</TableCell>
                <TableCell>Rec Amt</TableCell>
                <TableCell>Bal Amt</TableCell>
                <TableCell>Follow Date</TableCell>
                <TableCell>Follow Remarks</TableCell>
                <TableCell>Payment Remarks</TableCell>
                <TableCell sx={{ position: "sticky", right: 0, zIndex: 3 }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {bill.length > 0 ? (
                <>
                  {bill.map((row, partyIndex) => {
                    const pendingBills = row.pending_bills || [];

                    let totalAmt = 0,
                      paidAmt = 0,
                      remAmt = 0;

                    return (
                      <React.Fragment key={partyIndex}>
                        {pendingBills.map((billItem, billIndex) => {
                          const createdDate = new Date(billItem.created_at);
                          const today = new Date();
                          const diffInDays = Math.floor(
                            (today - createdDate) / (1000 * 3600 * 24)
                          );
                          const isEditable =
                            editableRow === `${partyIndex}-${billIndex}`;

                          totalAmt += parseFloat(billItem.total_amount || 0);
                          paidAmt += parseFloat(billItem.paid_amount || 0);
                          remAmt += parseFloat(billItem.rem_amount || 0);

                          return (
                            <TableRow
                              key={`${partyIndex}-${billIndex}`}
                              sx={{
                                backgroundColor:
                                  (partyIndex + billIndex) % 2 === 0
                                    ? "#fafafa"
                                    : "#ffffff",
                              }}
                            >
                              {billIndex === 0 && (
                                <>
                                  <TableCell rowSpan={pendingBills.length + 1}>
                                    {partyIndex + 1}
                                  </TableCell>
                                  <TableCell
                                    rowSpan={pendingBills.length + 1}
                                    sx={{
                                      maxWidth: "110px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {row.name}
                                  </TableCell>
                                </>
                              )}
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {billItem.branch_name === "RAIPUR"
                                  ? "SRE"
                                  : billItem.branch_name === "BILASPUR"
                                  ? "JHT"
                                  : "MBR"}
                                /{billItem.billing_id}/{getInitials(row.name)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {formatOnlyDate(billItem.created_at)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {diffInDays + 1}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {billItem.total_amount.toFixed(2)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {billItem.paid_amount.toFixed(2)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {billItem.rem_amount.toFixed(2)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {isEditable ? (
                                  <TextField
                                    size="small"
                                    type="date"
                                    value={editData.follow_date || ""}
                                    onChange={(e) =>
                                      setEditData({
                                        ...editData,
                                        follow_date: e.target.value,
                                      })
                                    }
                                    sx={{
                                      maxWidth: 130,
                                      "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: "0.75rem",
                                      },
                                    }}
                                  />
                                ) : billItem.follow_date ? (
                                  formatOnlyDate(billItem.follow_date)
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {isEditable ? (
                                  <TextField
                                    size="small"
                                    value={editData.remarks || ""}
                                    onChange={(e) =>
                                      setEditData({
                                        ...editData,
                                        remarks: e.target.value,
                                      })
                                    }
                                    sx={{
                                      maxWidth: 130,
                                      "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: "0.75rem",
                                      },
                                    }}
                                  />
                                ) : (
                                  billItem.remarks || "-"
                                )}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {isEditable ? (
                                  <TextField
                                    size="small"
                                    value={editData.payment_remarks || ""}
                                    onChange={(e) =>
                                      setEditData({
                                        ...editData,
                                        payment_remarks: e.target.value,
                                      })
                                    }
                                    sx={{
                                      maxWidth: 130,
                                      "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: "0.75rem",
                                      },
                                    }}
                                  />
                                ) : (
                                  billItem.payment_remarks || "-"
                                )}
                              </TableCell>

                              <TableCell
                                sx={{
                                  position: "sticky",
                                  right: 0,
                                  zIndex: 3,
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                      ? "#fafafa"
                                      : "#ffffff",
                                }}
                              >
                                {isEditable ? (
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    justifyContent="center"
                                  >
                                    <IconButton
                                      color="success"
                                      size="small"
                                      onClick={async () => {
                                        try {
                                          await billUpdate(
                                            billItem.billing_id,
                                            {
                                              follow_date:
                                                editData.follow_date === ""
                                                  ? null
                                                  : editData.follow_date,
                                              remarks: editData.remarks,
                                              payment_remarks:
                                                editData.payment_remarks,
                                            }
                                          );

                                          setEditableRow(null); // Row ko editable mode se hatao

                                          // Optionally fresh data fetch karo
                                          const data = await dashboardApi();
                                          if (data) {
                                            setBill(data.billing_data);
                                          }
                                        } catch (error) {
                                          console.error(
                                            "Update failed:",
                                            error
                                          );
                                        }
                                      }}
                                    >
                                      <AddIcon fontSize="small" />
                                    </IconButton>
                                  </Stack>
                                ) : (
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    justifyContent="center"
                                  >
                                    <IconButton
                                      size="small"
                                      color="primary"
                                      onClick={() => {
                                        setEditableRow(
                                          `${partyIndex}-${billIndex}`
                                        );
                                        setEditData({
                                          follow_date:
                                            billItem.follow_date || "",
                                          remarks: billItem.remarks || "",
                                          payment_remarks:
                                            billItem.payment_remarks || "",
                                        });
                                      }}
                                    >
                                      <Edit fontSize="small" />
                                    </IconButton>

                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() =>
                                        handleEditClick(billItem.billing_id)
                                      }
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </Stack>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}

                        <TableRow
                          sx={{
                            backgroundColor: "#e3f2fd",
                            fontWeight: "bold",
                          }}
                        >
                          <TableCell colSpan={3} align="right">
                            <strong>Total</strong>
                          </TableCell>
                          <TableCell>
                            <strong>{totalAmt.toFixed(2)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>{paidAmt.toFixed(2)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>{remAmt.toFixed(2)}</strong>
                          </TableCell>
                          <TableCell colSpan={4} />
                        </TableRow>
                      </React.Fragment>
                    );
                  })}

                  {/* 👉 FINAL TOTAL ROW */}
                  <TableRow
                    sx={{ backgroundColor: "#d0f0c0", fontWeight: "bold" }}
                  >
                    <TableCell colSpan={5} align="right">
                      <strong>Grand Total</strong>
                    </TableCell>
                    <TableCell>
                      <strong>
                        {bill
                          .flatMap((row) => row.pending_bills || [])
                          .reduce(
                            (sum, b) => sum + parseFloat(b.total_amount || 0),
                            0
                          )
                          .toFixed(2)}
                      </strong>
                    </TableCell>
                    <TableCell>
                      <strong>
                        {bill
                          .flatMap((row) => row.pending_bills || [])
                          .reduce(
                            (sum, b) => sum + parseFloat(b.paid_amount || 0),
                            0
                          )
                          .toFixed(2)}
                      </strong>
                    </TableCell>
                    <TableCell>
                      <strong>
                        {bill
                          .flatMap((row) => row.pending_bills || [])
                          .reduce(
                            (sum, b) => sum + parseFloat(b.rem_amount || 0),
                            0
                          )
                          .toFixed(2)}
                      </strong>
                    </TableCell>
                    <TableCell colSpan={4} />
                  </TableRow>
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={11} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          open={openEditModal}
          onClose={() => setOpenEditModal(false)}
          PaperProps={{
            style: {
              width: "1200px",
              height: "600px",
              maxWidth: "90%",
              overflow: "auto",
            },
          }}
        >
          <DialogContent>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOpenEditModal(false)}
              sx={{ height: "35px", marginRight: "10px" }}
            >
              Close
            </Button>
            <TableContainer sx={{ overflowX: "auto", maxHeight: "75vh" }}>
              <Table
                stickyHeader
                size="small"
                sx={{
                  tableLayout: "auto",
                  width: "auto",
                  "& td, & th": {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    padding: "4px 8px",
                    fontSize: "0.8125rem",
                    borderBottom: "1px solid #ccc",
                  },
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        fontWeight: "bold",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <TableCell>SR. No</TableCell>
                    <TableCell>Freight Id</TableCell>
                    <TableCell>Party Name</TableCell>
                    <TableCell>Branch Name</TableCell>
                    <TableCell>Loading Date</TableCell>
                    <TableCell>Unloading Date</TableCell>
                    <TableCell>Truck No.</TableCell>
                    <TableCell>D.O. No.</TableCell>
                    <TableCell>T.P. No.</TableCell>
                    <TableCell>From</TableCell>
                    <TableCell>To</TableCell>
                    <TableCell>Loading Wt</TableCell>
                    <TableCell>Receiving Wt</TableCell>
                    <TableCell>Shortage Wt</TableCell>
                    <TableCell>Billing Wt</TableCell>
                    <TableCell>Freight Rate</TableCell>
                    <TableCell>Freight Amt</TableCell>
                    <TableCell>TDS %</TableCell>
                    <TableCell>TDS Amt</TableCell>
                    <TableCell>Shortage Rate</TableCell>
                    <TableCell>Shortage Amt</TableCell>
                    <TableCell>Ad Mines</TableCell>
                    <TableCell>Ad Diesel</TableCell>
                    <TableCell>Ad Cash</TableCell>
                    <TableCell>Total Ad</TableCell>
                    <TableCell>Commission</TableCell>
                    <TableCell>Net Amt</TableCell>
                    <TableCell>Others Exp.</TableCell>
                    <TableCell>Net Payable</TableCell>
                    <TableCell>Truck Owner</TableCell>
                    <TableCell>Phone No.</TableCell>
                    <TableCell>PAN No.</TableCell>
                    <TableCell>Remark</TableCell>

                    <TableCell>Paid Amt</TableCell>
                    <TableCell>Bal Amt</TableCell>
                    <TableCell>Ref. No</TableCell>
                    <TableCell>Pay Id</TableCell>
                    <TableCell>Biil Date</TableCell>

                    <TableCell>Rec Amt</TableCell>
                    <TableCell>Diff Amt</TableCell>
                    <TableCell>Payment Remark</TableCell>
                    <TableCell>Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rawBillData.map((row, index) => (
                    <TableRow
                      key={row.freight_id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.freight_id}</TableCell>
                      <TableCell>{row.party_name}</TableCell>
                      <TableCell>{row.branch_name}</TableCell>
                      <TableCell>{row.loading_date}</TableCell>
                      <TableCell>{row.unloading_date}</TableCell>
                      <TableCell>{row.truck_no}</TableCell>
                      <TableCell>{row.do_no}</TableCell>
                      <TableCell>{row.tp_no}</TableCell>
                      <TableCell>{row.from_location}</TableCell>
                      <TableCell>{row.to_location}</TableCell>
                      <TableCell>{row.loading_wt}</TableCell>
                      <TableCell>{row.received_wt}</TableCell>
                      <TableCell>{row.shortage_wt}</TableCell>
                      <TableCell>{row.billing_wt}</TableCell>
                      <TableCell>{row.freight_rate}</TableCell>
                      <TableCell>{row.freight_amt}</TableCell>
                      <TableCell>{row.tds_per}</TableCell>
                      <TableCell>{row.tds_amt}</TableCell>
                      <TableCell>{row.shortage_rate}</TableCell>
                      <TableCell>{row.shortage_amt}</TableCell>
                      <TableCell>{row.ad_mines_exp}</TableCell>
                      <TableCell>{row.ad_diesel_exp}</TableCell>
                      <TableCell>{row.ad_cash_exp}</TableCell>
                      <TableCell>{row.total_advance}</TableCell>
                      <TableCell>{row.commission}</TableCell>
                      <TableCell>{row.net_amount}</TableCell>
                      <TableCell>{row.other_exp}</TableCell>
                      <TableCell>{row.net_payable}</TableCell>
                      <TableCell>{row.truck_owner}</TableCell>
                      <TableCell>{row.phone_no}</TableCell>
                      <TableCell>{row.pan_no}</TableCell>
                      <TableCell>{row.remark}</TableCell>

                      <TableCell>{row.paid_amount.toFixed(1)}</TableCell>
                      <TableCell>{row.bal_amount.toFixed(1)}</TableCell>

                      <TableCell>
                        {row.billing?.branch_name
                          ? `${
                              row.billing.branch_name === "RAIPUR"
                                ? "SRE"
                                : row.billing.branch_name === "BILASPUR"
                                ? "JHT"
                                : "MBR"
                            }/${row.billing.billing_id}/${getInitials(
                              row.billing.party_name
                            )}`
                          : "-"}
                      </TableCell>

                      <TableCell>
                        {row.freight_pay_ids && row.freight_pay_ids.length > 0
                          ? row.freight_pay_ids.join(", ")
                          : "-"}
                      </TableCell>

                      <TableCell>
                        {row.billing
                          ? formatOnlyDate(row.billing.created_at)
                          : ""}
                      </TableCell>

                      <TableCell className="no-print">
                        {row.receive_amount.toFixed(1)}
                      </TableCell>
                      <TableCell className="no-print">
                        {row.difference_amount.toFixed(1)}
                      </TableCell>
                      <TableCell className="no-print">
                        {row.payment_remark}
                      </TableCell>
                      <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </Dialog>
      </Card>
    </Box>
  );
}
